export const classes = {
    formControl: {
        width: '100%',
        backgroundColor: 'white',
        textAlign: 'left'
    },
    textTitle: {
        margin: 8,
        color: '#103168',
        fontWeight: 600,
        marginBottom: 30,
    },
    labelInput: {
        color: '#333333',
        fontWeight: 'bold',
        textAlign: 'left',
        fontSize: 14
    },
};
